"use client";
import { Button } from "@mui/material";
import React, { useState } from "react";
import Loading from "./loader";
import { toast } from "react-toastify";
import { FiEdit2, FiMoreVertical } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

export const PrimaryBtn = ({
  submit,
  text,
  disabled,
}: {
  submit: (e?: any) => any;
  text: string;
  disabled?: boolean;
}) => {
  const [className, setClassName] = useState("primary-button");

  const handleSubmit = async () => {
    setClassName("primary-button loading");
    try {
      const response = await submit();
      if (response?.success === true) setClassName("primary-button success");
      if (response?.error === true) setClassName("primary-button error");
    } catch (error) {
      console.error("Error submitting:", error);
      setClassName("primary-button error");
    } finally {
      setTimeout(() => {
        setClassName("primary-button");
      }, 200);
    }
  };

  return (
    <Button
      sx={{ textTransform: "none" }}
      variant="contained"
      color="primary"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        handleSubmit();
      }}
      disabled={disabled ?? className == "primary-button loading"}
    >
      {className === "primary-button loading" ? (
        <Loading size={20} girth={3} />
      ) : (
        <p className="f14 fw500"> {text}</p>
      )}
    </Button>
  );
};

export const SecondaryBtn = ({
  submit,
  text,
}: {
  submit: Function;
  text: string;
}) => {
  let className = "secondary-button";

  return (
    <>
      <Button
        sx={{ textTransform: "none" }}
        variant="outlined"
        className={"secondary-button"}
        onClick={(e) => {
          e.stopPropagation();
          submit();
        }}
      >
        <p className="f14 fw500"> {text}</p>
      </Button>
    </>
  );
};

export function CornerIconButton({
  type,
  position = "primary",
  iconSize,
  onClick,
  children,
}: {
  type: "edit" | "delete" | "remove" | "more" | "add";
  iconSize?: number;
  position?: "primary" | "secondary";
  onClick: (e: any) => void;
  children?: any;
}) {
  const [isLoading, setIsLoading] = useState(false);

  function getIcon() {
    if (children) return children;
    if (type === "edit") return <FiEdit2 size={iconSize || 16} />;
    if (type === "more") return <FiMoreVertical size={iconSize || 16} />;
    if (type === "add") return <IoMdAdd size={iconSize || 16} />;
    if (type === "delete") return <FaRegTrashAlt size={iconSize || 16} />;
    if (type === "remove")
      return <IoClose size={iconSize || 15} color="white"></IoClose>;
    return <FiEdit2 size={iconSize || 18} />;
  }

  async function onButtonClick(e: any) {
    try {
      e.stopPropagation();
      if (isLoading) return;
      setIsLoading(true);
      await onClick(e);
      setIsLoading(false);
    } catch (e: any) {
      toast.error(e?.message || e?.toString(), { position: "top-center" });
      setIsLoading(false);
      throw e;
    }
  }

  return (
    <div
      className={`cornerButton ${position} ${isLoading ? "loading" : ""}`}
      onClick={onButtonClick}
    >
      {isLoading ? <Loading size={20} girth={3}></Loading> : getIcon()}
    </div>
  );
}
